import React from 'react';
import { IConcreteJobConfirmationPopupProperties, IJobResultComponentProps } from '../jobs-monitor-host.viewmodel';
import {
    IGenerateAccessCodesJobDetails,
    IGenerateOrganizationsLinksJobResult
} from '../../../api/jobs.dao';

const generateOrganizationsLinksJobProperties:
    IConcreteJobConfirmationPopupProperties<IJobResultComponentProps<IGenerateAccessCodesJobDetails, IGenerateOrganizationsLinksJobResult>> = {
    reviewCompletedJobButtonText: 'Ok',
    reviewFailedJobButtonText: 'Ok',
    completeComponent: (props: IJobResultComponentProps<IGenerateAccessCodesJobDetails, IGenerateOrganizationsLinksJobResult>) => {

        const {countOfOrganizations} = props.result;

        return (
            <div className='alert-content'>
                <div className='alert-content__item'>Link generation complete</div>
                <div className='alert-content__item'>Links generated for {countOfOrganizations} Organizations</div>
            </div>
        );
    },
    failedComponent: () => {
        return <>Generation of presenter links has failed</>;
    }
};

export { generateOrganizationsLinksJobProperties };
